<template>
  <!-- 运维档案 -->
  <div class="container">
    <div class="file-list" style="display: flex;flex-wrap: wrap;" v-if="fileList !=null">
      <div class="file-item" v-for="item in fileList" @click="getFileType(item)">
        <div class="file-name">
          <div class="name">{{item.fileName}}</div>
          <a @click.stop="downUploadFile(item.id)">下载</a>
        </div>
        <div class="file-item-content">
          <img src="@/assets/others/index/file.png" />
        </div>
      </div>
    </div>
    <div v-else class="inner-img-none" style="color:#fff">暂无数据</div>
    <PDFModal ref="pdfview"></PDFModal>
  </div>
</template>

<script>
import { queryFileList } from '@/api/api'
import PDFModal from '@comp/PDFView/PDFModal'
export default {
  components: { PDFModal },
  data(){
    fileList:null
  },
  props:{
    companyId: {
      default: 0,
      type: Number
    },
  },
  watch:{
    companyId:{
      handler(val){
        if(val){
          this.getList()
        }
      },
      immediate:true
    }
  },
  methods:{
    getList(){
      queryFileList('site_company', this.companyId).then((res) => {
        if (res.success) {
          let docsList = []
          for (let i = 0; i < res.result.length; i++) {
            let doc = res.result[i]
            doc.key = doc.id
            docsList.push(doc)
          }
          this.fileList = docsList
          this.$forceUpdate()
        }
      })
    },
    // 预览
    openPDF(item) {
      this.$refs.pdfview.showPDF(item.id+'-'+item.fileName, window._CONFIG['domianURL'] + '/sys/common/file/view/' + item.id,
        'online')
    },
    /* 文件下载 */
    downUploadFile(text) {
      if (!text) {
        this.$message_custom('未知的文件','warning')
        return
      }
      window.open(window._CONFIG['domianURL'] + '/sys/common/file/download/' + text)
    },
    getFileType(item){
      if(item.suffixName.indexOf("png")==-1 && item.suffixName.indexOf("jpg")==-1 && item.suffixName.indexOf("svg")==-1 && item.suffixName.indexOf("jpeg")==-1){
        // 下载文件
        this.downUploadFile(item.id)
      }else{
        // 预览图片
        this.openPDF(item)
      }
    }
  },

}

</script>


<style lang="scss" scoped>
.container {
  width: 100%;

  .none {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .file-list {
    margin: 10px;
    .file-item {
      height: 170px;
      width: 23%;
      border-radius: 10px;
      border: 2px solid #0c3784;
      text-align: center;
      box-shadow: 0 0 10px #0c3784;
      animation: name .9s linear;
      margin: 10px;
      .file-name{
        font-size: 16px;
        color: #ccc;
        height: 50px;
        line-height: 50px;
        border-bottom: 3px solid #0c3784;
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
        padding: 0 15px;
        display: flex;
        justify-content: space-between;
        .name{
          width: 280px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .file-item-content {
        img{
          width: 100px;
          margin-top: 10px;
          cursor: pointer;
        }
      }
    }
  }
  ::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }
  .inner-img-none {
    font-size: 50px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 25%;
    color: #000;
  }
}
</style>